export class ApiError extends Error {
  readonly statusCode: number;
  constructor(statusCode?: number, message?: string) {
    super(message ? message : statusCode ? `${statusCode}` : undefined);
    this.statusCode = statusCode ?? 500;
  }
}
